import React from 'react';
import PropTypes from 'prop-types';
import { MdPerson, MdPersonOutline } from 'react-icons/lib/md';
import ReactTooltip from 'react-tooltip';

const Avatar = ({ name, isActive }) => {
  var chars = name.trim().split(/\s+/g).map(s => s.charAt(0));
  const initials = ( chars.shift() || '' ) + ( chars.pop() || '' );
  return <span className='avatar-container'>
    <span className="avatar">{initials}</span> 
    {isActive !== undefined && 
      <span className='avatar-status-icon'>
        {isActive === true  && <MdPerson className='active-user' data-for='user-icon' data-tip="In DDC"/>}
        {isActive === false && <MdPersonOutline className='user-icon inactive-user' data-for='user-icon' data-tip="Not in DDC"/>}
        {isActive === null && <MdPersonOutline className='user-icon unknown-status-user' data-for='user-icon' data-tip="Status Unknown"/>}
        <ReactTooltip id='user-icon'/>
      </span>
    }
    </span>;
}

Avatar.propTypes = {
  name: PropTypes.string.isRequired,
  isActive: PropTypes.bool
}

export default Avatar;
